import React from 'react'
import HomePage from '../home'
import Formsy from 'formsy-react'
import MyPage from '../../components/MyPage'
import MyInput from '../../components/MyInput'
import MySelect from '../../components/MySelect'
import MyTable from '../../components/MyTable'
import MyTableHeaderSort from '../../components/MyTableHeaderSort'
// import SelectSessionsModal from './SelectSessionsModal'
import ErrorMessage from '../../components/errormessage'
import DeleteIcon from '@material-ui/icons/Delete'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button } from '@material-ui/core'
import TextAreaWithLabel from '../../components/TextAreaWithLabel'

import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import '../../components/QuillEditor/quill.css'
import quillSettings from '../../components/QuillEditor/quillSettings'

import { actions as storiesActions } from '../../redux/modules/successStories'
import { actions as authorActions } from '../../redux/modules/authors'
import { actions as diagnosisActions } from '../../redux/modules/diagnosis'

class SuccessStoryEdit extends MyPage {
  constructor (props) {
    super(props)
    const obj = this.getObject()

    console.log('obj: ', obj)

    this.state = {
      object: obj,
      title: obj.title,
      quote: obj.quote,
      details: obj.details,
      selectedDiagnoses: obj.diagnoses.map(diagnosis => {
        return { value: diagnosis }
      }) || [],
      diagnosesOptions: [],
      authorId: obj.authorId,
      authorOptions: [],
      errorMessage: '',
      canSubmit: false,
      showValidationErrors: false,
      isLoading: true,
      openDialog: false
    }
  }

  getObject = () => {
    if (this.props.location.state && this.props.location.state.obj) {
      console.log(this.props.location.state.obj)
      return this.props.location.state.obj
    } else {
      return {
        title: '',
        quote: '',
        details: '',
        diagnoses: [],
        authorId: null
        // sessions: []
      }
    }
  }

  getTexts = () => {
    return {
      pageTitle: 'Success Story'
    }
  }

  handleChangeFor = field => (value) => {
    this.setState({ [field]: value })
  }

  save = async (event) => {
    event.preventDefault()
    if (window.confirm('Are you sure you want to save this Success Story?')) {
      this.state.object.title = this.state.title
      this.state.object.quote = this.state.quote
      this.state.object.details = this.state.details
      this.state.object.authorId = this.state.authorId
      this.state.object.diagnoses = this.state.selectedDiagnoses.map(diagnosis => {
        return diagnosis.value
      })

      const result = await storiesActions.save(this.state.object)
      if (result) {
        if (!result.success) {
          this.setState({ errorMessage: result.error })
        } else {
          this.cancel(event)
          this.setState({ errorMessage: '' })
        }
      }
    }
  }

  /*
  handleDeleteSession = (e, item) => {
    for (let i = 0; i < this.state.sessionsList.length; i++) {
      if (this.state.sessionsList[i] === item) {
        this.setState({
          deleteSessionIndex: i,
        })

        break
      }
    }

    this.handleOpenDialog()
  }

  handleOpenDialog = () => {
    this.setState({
      openDialog: true,
    })
  }

  handleCloseDialog = value => {
    this.setState({
      isLoading: false,
      openDialog: false,
      deleteSessionId: null,
      deleteTitle: null
    })
  }

  handleConfirmDialog = async => {
    if (this.state.deleteSessionIndex >= 0) {
      const list = this.state.sessionsList
      list.splice(this.state.deleteSessionIndex, 1)
      this.setState({ sessionsList: list })
    }

    this.handleCloseDialog()
  }

  handleChange = e => {
    e.preventDefault()
    console.log('handleChange e: ', e)
    this.setState({
        [e.target.id]: e.target.value
    })
  }
  */

  cancel = e => {
    e.preventDefault()
    this.props.router.push('/success-stories-list')
  }

  /*
  addSessionToList = async obj => {
    this.setState({ sessionsList: obj.sessions || [] })
  }

  
  */

  async componentDidMount () {
    const authorsList = await authorActions.getAuthorList()
    const authorOptions = [{ value: null, label: 'None' }].concat(
      authorsList.map(element => {
        return { value: element._id, label: element.name }
      })
    )

    const diagnosesList = await diagnosisActions.getDiagnosisList()
    const diagnosesOptions = diagnosesList
      .sort((a, b) => a.title.localeCompare(b.title))
      .map(item => {
        return { value: item._id, label: item.title }
      })

    this.setState({
      authorOptions,
      diagnosesOptions,
      isLoading: false
    })
  }

  /*
  makeToolBar = () => {
    return (
      <div
        className="device-tools"
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <div>
          <SelectSessionsModal
            sessions={this.state.object.allSessions}
            selectedSessions={this.state.object.sessions}
            object={this.state.object}
            onExit={this.addSessionToList}
          />
        </div>
      </div>
    )
  }

  makeHead = () => {
    return (
      <div className={'table-head'}>
        <div style={{ width: '80%', paddingLeft: '15px' }}>
          <MyTableHeaderSort label="Session" />
        </div>

        <div style={{ width: '20%', paddingLeft: '15px' }}>
          <MyTableHeaderSort label="Actions" />
        </div>
      </div>
    )
  }

  makeRow = item => {
    return (
      <div className={'table-row'}>
        <div style={{ width: '80%', paddingLeft: '15px' }}>{item.title}</div>

        <div style={{ width: '20%', paddingLeft: '15px' }}>
          <button
            type="button"
            className="btn"
            onClick={e => this.handleDeleteSession(e, item)}
          >
            <DeleteIcon />
          </button>
        </div>
      </div>
    )
  }
  */

  render () {
    const style = { color: 'red' }
    return (
      <HomePage router={this.props.router}>
        <div className="devices-page-wrapper">
          <ErrorMessage text={this.state.errorMessage} />
          <h3>{this.getTexts().pageTitle}</h3>
        {!this.state.isLoading && (
            <Formsy
              className="create-device-form"
              onValidSubmit={this.submit}
              onInvalidSubmit={() =>
                this.setState({ showValidationErrors: true })
              }
              onValid={() => this.setState({ canSubmit: true })}
              onInvalid={() => this.setState({ canSubmit: false })}
            >

              
              <div className="create-device-row">
                <label>
                  Title <span style={style}>*</span>
                </label>
                <MyInput
                  id="title"
                  name="title"
                  classNameDiv="create-branch-row"
                  className="create-device-input"
                  autocomplete="off"
                  value={this.state.title}
                  onChange={this.handleChange}
                  required
                  showError={this.state.showValidationErrors}
                />
              </div>

              <div className="create-device-row">
                  <label>Author</label>
                  <MySelect
                    stateField="authorId"
                    className="create-branch-select"
                    value={this.state.authorId}
                    options={this.state.authorOptions}
                    onChange={this.handleSelect}
                  />
                  {this.state.showValidationErrors && !this.state.authorId &&
                    <ErrorMessage text="This field is required" />
                  }
                </div>

              <div className="create-device-row">
                <label>
                  Diagnoses
                </label>

                <MySelect
                  stateField="selectedDiagnoses"
                  className="create-branch-select"
                  value={this.state.selectedDiagnoses}
                  options={this.state.diagnosesOptions}
                  onChange={this.handleSelect}
                  isMulti={true}
                  isSearchable={true}
                />
                {this.state.showValidationErrors && this.state.selectedDiagnoses.length === 0 &&
                  <ErrorMessage text="This field is required" />
                }
              </div>

              <div className="create-device-row">
                <label>
                  Quote <span style={style}>*</span>
                </label>

                <textarea
                  id="quote"
                  name="quote"
                  className='create-device-input'
                  rows={5}
                  value={this.state.quote}
                  onChange={this.handleChange}
                />
              </div>

              <div className="create-device-row">
                <label>
                  Details <span style={style}>*</span>
                </label>
                
                <ReactQuill
                  required
                  value={this.state.details}
                  onChange={this.handleChangeFor('details')}
                  theme={quillSettings.theme}
                  modules={quillSettings.modules}
                  />

              </div>
              
              <button
                className="btn green mr-2"
                type="submit"
                onClick={this.state.canSubmit ? this.save : undefined}
              >
                Save
              </button>
              <button
                className="btn blue mr-2"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
            </Formsy>
        )}
        </div>
        {/* <Dialog
          onClose={this.handleCloseDialog}
          open={this.state.openDialog}
          aria-labelledby="delete-dialog-title"
        >
          <DialogTitle id="simple-dialog-title">
            Are you sure you want to delete session "{this.state.deleteTitle}"?
          </DialogTitle>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 24px 24px 24px'
          }}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCloseDialog}>Cancel</Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.handleConfirmDialog}>Ok</Button>
          </div>
        </Dialog> */}
      </HomePage>
    )
  }
}

export default SuccessStoryEdit
